// extracted by mini-css-extract-plugin
module.exports = {"switcher":"HHhz","tabs":"HHsz","tabBtn":"HHab-","wrapper":"HHf","desk":"HHacb","mobile":"HHed","tab":"HHs1","list":"HHar","item":"HHat","advMarker":"HHlx"};